<template>
  <div id="aqt_content">
    <div class="content_body">
      <div class="personal_head">
        <div class="line line1"></div>
        <p class="personal_title">关于阿启泰</p>
        <p class="head_content">内蒙古阿启泰科技有限公司在2016年2月成立于内蒙古自治区呼和浩特市，是由90后的年轻人员组成的互联网团队。阿启泰团队自创立以来在IT领域为客户提供有竞争力、安全、可信赖的产品解决方案与服务。持续为客户创造价值、释放团队潜能、激发组织创新、坚持稳中求胜、踏踏实实长期投入，厚积薄发。坚持以客户服务为中心，以奋斗者为本，长期艰苦奋斗，不断探索新技术。我们不会辜负时代赋予我们的历史性机遇，逐梦同行。</p>
        <div class="head_content2">
          <img src="../../assets/img/serve2.png" class="head_img1">
          <p class="head_more">创造科技的无限可能性</p>
          <img src="../../assets/img/serve3.png" class="head_img1">
        </div>
        <img src="../../assets/img/personal1.png" class="head_img2"/>
      </div>
      <div class="personal_info">
        <div class="line line1"></div>
        <p class="info_title">阿启泰资质证明</p>
        <div class="info_content">
          <img src="../../assets/img/personal4.png" class="info_left">
          <ul class="info_right">
            <li class="info_right_item">
              <img src="../../assets/img/personal5.png" class="item_img"/>
              <p class="item_name">阿启泰游牧文化系统软件</p>
            </li>
            <li class="info_right_item">
              <img src="../../assets/img/personal6.png" class="item_img"/>
              <p class="item_name">掌上蒙汉双语图书馆系统</p>
            </li>
            <li class="info_right_item">
              <img src="../../assets/img/personal5.png" class="item_img"/>
              <p class="item_name">民俗数据库系统</p>
            </li>
            <li class="info_right_item">
              <img src="../../assets/img/personal6.png" class="item_img"/>
              <p class="item_name">智慧牧场软件开发运行维护监控软件</p>
            </li>
            <li class="info_right_item">
              <img src="../../assets/img/personal7.png" class="item_img"/>
              <p class="item_name">民歌民乐大数据平台系统</p>
            </li>
            <li class="info_right_item">
              <img src="../../assets/img/personal8.png" class="item_img"/>
              <p class="item_name">待更新</p>
            </li>
          
          </ul>
        </div>
        <div class="credential">
          <img v-for="(item,index) in imgarr" :key="index" :src="require(`../../assets/img/${item}`)"  class="credential_img"/>
          
          <!-- <img src="../../assets/img/personal9.png"  class="credential_img"/>
          <img src="../../assets/img/personal11.png"  class="credential_img"/>
          <img src="../../assets/img/personal18.jpg" class="credential_img"/>
          <img src="../../assets/img/personal10.png" class="credential_img"/>
          <img src="../../assets/img/personal19.jpg" class="credential_img"/>
          <img src="../../assets/img/personal20.jpeg" class="credential_img"/> -->
        </div>
        <div class="time_line">
          <div class="time_head">
            <img src="../../assets/img/personal12.png" class="time_img"/>
            <div class="line line2"></div>
            <p class="time_name">时间线</p>
          </div>
          <section style="margin-left: 3%">
            <div class="time_items time_items1">
              <div class="progress_item">
                <p class="item_time">2016年02月</p>
              </div>
              <img src="../../assets/img/personal13.png" class="progress_img"/>
              <p class="progress_content">内蒙古阿启泰科技有限公司正式成立</p>
              <div  class="column_line column_line1"></div>
              <img src="../../assets/img/personal14.png" class="progress_left"/>
            </div>
            <div class="time_items time_items2">
              <div class="progress_item">
                <p class="item_time">2016年12月</p>
              </div>
              <img src="../../assets/img/personal13.png" class="progress_img"/>
              <p class="progress_content">游牧文化发布会</p>
              <div  class="column_line column_line2"></div>
            </div>
            <div class="time_items time_items2">
              <p class="progress_content_left">内蒙古电视台采访报道</p>
              <img src="../../assets/img/personal13.png" class="progress_img"/>
    
              <div class="progress_item">
                <p class="item_time_right">2017年01月</p>
              </div>
              <div  class="column_line column_line2"></div>
            </div>
            <div class="time_items time_items1">
              <div class="progress_item ">
                <p class="item_time">2017年02月</p>
              </div>
              <img src="../../assets/img/personal13.png" class="progress_img"/>
              <p class="progress_content">成立1周年</p>
              <div  class="column_line column_line1"></div>
              <img src="../../assets/img/index2.png" class="progress_right"/>
            </div>
            <div class="time_items time_items1">
              <div class="progress_item">
                <p class="item_time">2017年03月</p>
              </div>
              <img src="../../assets/img/personal13.png" class="progress_img"/>
              <p class="progress_content">游牧书屋正式发布</p>
              <div  class="column_line column_line1"></div>
              <img src="../../assets/img/personal15.png" class="progress_left"/>
            </div>
            <div class="time_items time_items2">
              <p class="progress_content_left">游牧书屋正式发布</p>
              <img src="../../assets/img/personal13.png" class="progress_img"/>
    
              <div class="progress_item">
                <p class="item_time_right">2017年01月</p>
              </div>
              <div  class="column_line column_line2"></div>
            </div>
            <div class="time_items time_items1 time_new">
              <div class="progress_item ">
                <p class="item_time">2017年03月</p>
              </div>
              <img src="../../assets/img/personal13.png" class="progress_img"/>
              <p class="progress_content">参加创新创业获奖</p>
              <div  class="column_line column_line2"></div>
              <img src="../../assets/img/personal16.png" class="progress_right"/>
              <img src="../../assets/img/8.png" class="last_img"/>
              <p class="common">与阿启泰一起逐梦同行</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style  scoped lang="less">
#aqt_content{
  background:url('../../assets/img/personal_last.png') no-repeat;
  background-size: 100% 20%;
  background-position:bottom;
  padding-top:70px;
  overflow:hidden;
  .content_body{
    width:70%;
    height:auto;
    margin:0px auto;
    .line{
      width:10%;
      height:1px ;
    }
    .line1{
      background-color:#F5A623;
      margin:50px auto;
    }
    .line2{
      background-color:#F5A623;
      margin:20px auto;
    }
    .personal_head {
      width: 100%;
      height: auto;
      .personal_title{
        color:#F4FAFF;
        font-size:18px;
        text-align:center;
      }
      .head_content{
        color:#D3DFFF;
        font-size:14px;
        letter-spacing: 2px;
        margin-top:30px;
        line-height:25px;
        text-align:center;
      }
      .head_content2{
        width: 70%;
        height: auto;
        margin: 50px auto;
        padding-left: 13%;
        box-sizing: border-box;
        display:flex;
        flex-direction:row;
        .head_img1{
          height:30px;
          
        }
        .head_more{
          font-size: 18px;
          color: #F4FAFF;
          line-height: 40px;
          margin-left: 10%;
          margin-right: 10%;
        }
        
      }
      .head_img2{
        width:50%;
        margin-left:25%;
      }
    }
    .personal_info{
      width:100%;
      height:auto;
      .info_title{
        color:#F4FAFF;
        font-size:16px;
        text-align:center;
        margin-bottom:50px;
      }
      .info_content{
        width:100%;
        height:auto;
        display:flex;
        flex-direction:row;
        .info_left{
          width:30%;
        }
        .info_right{
          width:70%;
          height:auto;
          margin-top:40px;
          .info_right_item{
            width:70%;
            height:auto;
            margin-left:30%;
            margin-top:5%;
            display:flex;
            flex-direction:row;
            .item_img{
              height:15px;
              margin-top:3px;
            }
            .item_name{
              font-size:14px;
              color:#D3DFFF;
              margin-left:2%;
            }
          }
        }
      }
      .credential{
        width:100%;
        height:auto;
        /*background-color:red;*/
        display:flex;
        flex-direction:row;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top:100px;
        .credential_img{
          /*width:30%;*/
          width:49%;
          margin-bottom:2%;
        }
      }
      .time_line{
        width:100%;
        height:100%;
        .time_head{
          width:100%;
          //height:100px;
          margin-top:100px;
          margin-bottom:60px;
          .time_img{
            width:8%;
            margin-left:46%;
          }
          .time_name{
            color:#F4FAFF;
            font-size:14px;
            text-align:center;
          }
        }
        .time_items1{
          height:14rem;
        }
        .time_items2{
          height:8rem;
        }
        .time_items{
          width:100%;
          display:flex;
          flex-direction:row;
          position:relative;
          .common{
            position:absolute;
            bottom:0;
            left:50%;
            font-size:18px;
            color:#FFFFFF;
            bottom: -15%;
            left: 37%;
          }
          .progress_item{
            width:43.5%;
            height:30px;
            margin-left:2%;
            margin-right:2%;
            .item_time{
              width: 25%;
              height: 20px;
              margin-left: 70%;
              text-align:center;
              border:1px solid #6A98F1;
              color:#6A98F1;
              border-radius:50px;
            }
            
          }
          .last_img{
            width:18px;
            position:absolute;
            left: 47.6%;
            top: 66%;
          }
          .progress_img{
            width:2%;
            height:15px;
          }
          .progress_content{
            width:43.5%;
            height:30px;
            margin-left:2%;
            margin-right:2%;
            color:#FFFFFF;
            font-size:14px;
          }
          .progress_content_left{
            width:43.5%;
            height:30px;
            margin-left:2%;
            margin-right:2%;
            text-align:right;
            color:#FFFFFF;
            font-size:14px;
          }
          .item_time_right{
            width: 25%;
            height: 20px;
            margin-left:0;
            text-align:center;
            border:1px solid #6A98F1;
            color:#6A98F1;
            border-radius:50px;
          }
          .progress_right{
            width: 23%;
            position: absolute;
            left: 55%;
            top: -10%;
          }
          .column_line1{
            height:13rem
          }
          .column_line2{
            height:8rem;
          }
          .column_line{
            position:absolute;
            top:8%;
            left: 48.5%;
            border-left: 1px dashed #F59D3E;
            line-height:1px;
            z-index:88;
          }
          .progress_left{
            width: 23%;
            position: absolute;
            left: 20%;
            top: 8%;
          }
          
          
        }
      }
      
    }
  }
}
</style>
